// Amateur Topic 1 — Support and Resistance. Very simple English.
export default {
  title: 'Support and Resistance',
  summary: 'The invisible floors and ceilings on your chart.',
  subtopics: [
    {
      title: 'What is SNR?', scene: 'snrWhat',
      cards: [
        { icon: '🟩', title: 'Support = floor', body: 'Support is a price level where the price keeps stopping and bouncing UP, like a ball bouncing on the floor.' },
        { icon: '🟥', title: 'Resistance = ceiling', body: 'Resistance is a price level where the price keeps stopping and falling DOWN, like a ball hitting the ceiling.' },
        { icon: '🔤', title: 'SNR', body: 'SNR is short for Support aNd Resistance. Traders draw these as lines (or thin zones) on the chart.' },
        { icon: '🎯', title: 'A zone, not a laser', body: 'Price rarely stops at the exact same cent. Think of SNR as a small area, like a thick line, not a thin laser beam.' },
      ],
    },
    {
      title: 'How it Happens', scene: 'snrHow',
      cards: [
        { icon: '🔁', title: 'Again and again', body: 'A level becomes SNR when the price touches it and turns around more than once.' },
        { icon: '✌️', title: 'Two touches', body: 'Two touches make a level interesting. Three or more touches make it stronger and easier to see.' },
        { icon: '👀', title: 'Look left', body: 'To find SNR, look back to the left of your chart. Where did price turn around before? Draw a line there.' },
        { icon: '🕰️', title: 'Bigger timeframe, stronger level', body: 'A level seen on the daily (D1) or 4-hour (H4) chart is usually stronger than one seen on a 5-minute chart.' },
      ],
    },
    {
      title: 'Why it Happens', scene: 'snrWhy',
      cards: [
        { icon: '🧠', title: 'People remember', body: 'Traders remember where price turned before. When it comes back, many of them act again at the same place.' },
        { icon: '📚', title: 'Orders waiting', body: 'Lots of people put buy orders, sell orders and stop losses near the same levels. All those orders together can push the price away.' },
        { icon: '💯', title: 'Round numbers', body: 'People love round numbers like gold at 2,400 or 2,500. Many orders sit there, so price often reacts at these numbers.' },
        { icon: '😟', title: 'Feelings', body: 'Someone who bought too high and waited in a loss is happy to sell when price comes back to their entry. That selling can make a ceiling.' },
      ],
    },
    {
      title: 'How to Use It', scene: 'snrUse',
      cards: [
        { icon: '🟢', title: 'Buy near the floor', body: 'Think about BUYING when price comes down to support. You buy close to the floor, so your risk is small.' },
        { icon: '🔴', title: 'Sell near the ceiling', body: 'Think about SELLING when price goes up to resistance.' },
        { icon: '🛑', title: 'Stop loss on the other side', body: 'Put your stop loss a little beyond the level: below support when buying, above resistance when selling. If the level breaks, you are out with a small loss.' },
        { icon: '✋', title: 'Wait for a sign', body: 'Don\'t jump in just because price touched the line. Wait for a sign, like a strong candle bouncing away from the level.' },
      ],
    },
  ],
};
